import React, { useEffect, useState } from 'react'
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5'
import uniqueId from 'lodash/uniqueId'

const InputText: React.FC<InputTextProps> = ({
  label = '',
  password = false,
  placeholder = '',
  size = 'default',
  hidden = false,
  value,
  defaultValue,
  name,
  error,
  register,
  rules,
  phone = false,
  containerClasses,
  title,
  innerProps,
  maxLength = 56,
  onCheckIfExist = () => {},
  isUpperValue = false,
  disableInput = false,
  alreadySubmitted = false,
  onChangeValue = () => {}
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const randomId = uniqueId('label-')
  const [valueInput, setValueInput] = useState(value)

  const checkPatterns = () => {
    if (valueInput && phone) {
      // console.log('rules', rules)
      return new RegExp(rules.pattern.value).test(valueInput)
    }
  }

  useEffect(() => {
    if (phone) {
      // console.log('rules', rules)
    }
  }, [rules])

  return (
    <div className={`${containerClasses}`}>
      {!hidden && (
        <label
          htmlFor={randomId}
          className="font-medium text-primary-900 text-xs dark:text-white"
        >
          {label}
        </label>
      )}
      <div className="w-full mb-2 relative">
        <input
          onBlur={() => onCheckIfExist()}
          maxLength={maxLength}
          style={title ? { fontSize: '30px', border: '0' } : {}}
          className={`custom-input cursor-text transition w-full ${
            !title && 'dark:bg-gray-600 dark:border-gray-600 dark:text-white hover:bg-primaryGray-300 dark:hover:bg-primaryGray-600'
          } ${
            title &&
            'dark:bg-black dark:border-black dark:text-white focus:border-transparent hover:bg-primaryGray-300 dark:hover:bg-primaryGray-600'
          } 
        ${
          size === 'small'
            ? 'h-inputSmall'
            : size === 'large'
            ? 'h-inputLarge'
            : 'h-inputDefault '
        } 
        ${error ? 'border-danger focus:border-danger' : ''}`}
          id={randomId}
          name={name || undefined}
          placeholder={placeholder}
          type={password && !showPassword ? 'password' : 'text'}
          hidden={hidden}
          value={valueInput && valueInput}
          defaultValue={
            defaultValue && (phone ? defaultValue.number : defaultValue)
          }
          readOnly={value || disableInput ? true : false}
          ref={register ? register(rules) : undefined}
          autoComplete="off"
          onChange={(e) => {
            if (isUpperValue) {
              setValueInput(e?.target?.value?.toUpperCase())
            } else {
              onChangeValue(e?.target?.value)
              setValueInput(e?.target?.value)
            }
          }}
          {...innerProps}
        />
        {password && (
          <div className="text-gray-500 bg-transparent dark p-1 cursor-pointer absolute right-0 bottom-0 h-full flex items-center">
            {!showPassword ? (
              <IoEyeOutline onClick={() => setShowPassword(true)} />
            ) : (
              <IoEyeOffOutline onClick={() => setShowPassword(false)} />
            )}
          </div>
        )}
        {/* {phone && alreadySubmitted && !valueInput && (
          <p className="text-danger dark:text-danger-dark mt-2">
            {rules.required}
          </p>
        )}
        {phone && alreadySubmitted && valueInput && !checkPatterns() && (
          <p className="text-danger dark:text-danger-dark mt-2">
            {rules.pattern.message}
          </p>
        )} */}
      </div>
    </div>
  )
}

export default InputText

type InputProps = JSX.IntrinsicElements['input']

interface InputTextProps {
  label?: string
  placeholder?: string
  password?: boolean
  size?: 'small' | 'large' | 'default'
  hidden?: boolean
  value?: string
  defaultValue?: any // usado por ahora en lista de clientes y proveedores para cargar numeros de telefonos
  containerClasses?: any
  title?: boolean
  phone?: boolean
  innerProps?: InputProps
  [key: string]: any
  onCheckIfExist?: Function
  isUpperValue?: boolean
  disableInput?: boolean
  alreadySubmitted?: boolean
  onChangeValue?: (value: any) => void
}
